export function slideToggleEvents() {
	const containers = document.querySelectorAll(".flux-slide-toggles");
	if (!containers.length) return;
	containers.forEach((container) => {
		async function onFirstClick(e) {
			container.removeEventListener("click", onFirstClick);
			try {
				const { initSlideToggle } = await import("./slide-toggle.js");
				const toggleSection = initSlideToggle(container);
				toggleSection(e);
			} catch (err) {
				console.error("Failed to load slide toggle module:", err);
			}
		}
		container.addEventListener("click", onFirstClick);
	});
}
